import React from "react";
import styled from "styled-components";

interface IProps
  extends React.HTMLAttributes<HTMLOListElement | HTMLUListElement> {
  items: Array<React.ReactElement<HTMLElement>>;
  inOrder?: boolean;
}
const List: React.FC<IProps> = ({ items, inOrder = true, ...props }) => {
  const listItems = items.map((item, i) => <Li key={i}>{item}</Li>);
  return inOrder ? (
    <Ol {...props}>{listItems}</Ol>
  ) : (
    <Ul {...props}>{listItems}</Ul>
  );
};

const Li = styled.li``;
const Ol = styled.ol``;
const Ul = styled.ul``;

export default List;
